import dayjs from 'dayjs';
import localeData from 'dayjs/plugin/localeData';
import weekday from 'dayjs/plugin/weekday';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import weekYear from 'dayjs/plugin/weekYear';

dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);

export const checkAndSetGermanDateFormat = (item) => {
  const parsedDate = new Date(item);
  if (
    !isNaN(parsedDate) &&
    !isNaN(Date.parse(item)) &&
    item === parsedDate.toISOString().split('T')[0]
  ) {
    return dayjs(item);
  }
  return item;
};

/**
 * Prüft ob ein Wert ein dayjs-Objekt ist (kommt von Ant Design DatePicker).
 * Gibt ISO-String "YYYY-MM-DD" zurück, oder null wenn kein Datum.
 */
export const dayjsToISO = (value) => {
  if (!value) return null;
  if (typeof value === 'object' && typeof value.format === 'function') {
    return value.format('YYYY-MM-DD');
  }
  return null;
};

export const checkAndSetUSFormat = (item) => {
  const dateRegex = /^\d{2}\.\d{2}\.\d{4}$/;
  if (dateRegex.test(item)) {
    const [day, month, year] = item.split('.');
    return `${year}-${month}-${day}`;
  }
  const numberRegex = /^-?\d+(?:\.\d{3})*(?:,\d+)?$/;
  if (numberRegex.test(item)) {
    return item.replace(/\./g, 'X').replace(/,/g, '.').replace('X', ',');
  }
  return item;
};
